import React from 'react';

import { Badge, BadgeProps, Group } from '@mantine/core';
import { AthletePackage } from 'types';

const statusColorMap = {
  UPCOMING: 'kiloBlue',
  ACTIVE: 'green',
  HOLD: 'yellow',
  CANCELLED: 'red',
  ENDED: 'red',
};

const PackageStatusBadge = ({
  status,
  isCancelEarly = false,
  fullWidth = true,
  size = 'xs',
  isDesktop = true,
  ...badgeProps
}: BadgeProps & {
  status: AthletePackage['status'];
  isDesktop?: boolean;
  isCancelEarly?: boolean;
}): JSX.Element | null => {
  if (!status || !(status in statusColorMap)) return null;

  if (!isCancelEarly) {
    return (
      <Badge
        color={statusColorMap[status]}
        variant='filled'
        fullWidth={fullWidth}
        size={size}
        {...badgeProps}
      >
        {isDesktop ? status : status[0]}
      </Badge>
    );
  }
  return (
    <Group noWrap spacing={0}>
      <Badge
        color={statusColorMap[status]}
        variant='filled'
        fullWidth={fullWidth}
        size={size}
        sx={{ borderTopRightRadius: '1px', borderBottomRightRadius: '1px' }}
        {...badgeProps}
      >
        {isDesktop ? status : status[0]}
      </Badge>
      <Badge
        color={'orange'}
        variant='filled'
        fullWidth={fullWidth}
        size={size}
        sx={{ borderTopLeftRadius: '1px', borderBottomLeftRadius: '1px' }}
        {...badgeProps}
      >
        {'Canceling'}
      </Badge>
    </Group>
  );
};

export default PackageStatusBadge;
